import { ViewportScroller } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndexComponent implements OnInit {

  constructor(private router:Router,private viewportScroller: ViewportScroller) {
    this.removeCssById("css_landing");
    this.loadStyle("assets/index/css/vendor/font-awesome.css");
    this.loadStyle("assets/index/css/vendor/slick.css");
    this.loadStyle("assets/index/css/vendor/slick-theme.css");
    this.loadStyle("assets/index/css/vendor/animate/animate.min.css");
    this.loadStyle("assets/index/app.css");
    this.loadScript("assets/index/app.js");
    this.loadScript("assets/index/js/slick.min.js");
    const scrollTarget = localStorage.getItem('scrollTarget');
    if (scrollTarget) {
      if(scrollTarget!="index"){
        setTimeout(() => {
          this.smoothScroll(scrollTarget);
        }, 600);
      }else {
        localStorage.removeItem('scrollTarget');
        $('.fa-times').trigger('click');
      }
      // sessionStorage.removeItem('scrollTarget');
      
    }
   }


  mobile:any=false;
  medium:any=false;
  logged:any;
  currentYear: number = new Date().getFullYear();
  ngOnInit(): void {
    
    $("#preloader").show("slow");
    $(".logo_navbar").css("max-width","8% !important");
    this.preloader();
    setTimeout(()=>{
      let footer:any = document.getElementsByClassName("footer-section");      
      footer[0].style.display = "none";
      $(document).ready(function(){          
        if ($(".mobile-nav__toggler").length && this.mobile) {          
          $(".mobile-nav__toggler").on("click", function (e) {            
            e.preventDefault();
            if($(".mobile-nav__wrapper").hasClass("expanded")){
              $(".mobile-nav__wrapper").addClass("expanded");
              $("body").addClass("locked");
            }else {
              $(".mobile-nav__wrapper").removeClass("expanded");
              $("body").removeClass("locked");
            }
          });
        }
        $(".mobile-nav__wrapper").removeClass("expanded");
        $("body").removeClass("locked");
      });
    },2000);
    
    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668) this.medium = true;
    }else {
      this.mobile = false;
    }
    var role;
    if(localStorage.getItem("role")!=undefined) {
      this.logged=localStorage.getItem("logged");
      role = localStorage.getItem("role");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.logged=sessionStorage.getItem("logged");
      role = sessionStorage.getItem("role");
    }
    if(this.logged){
      if(role ==="adm") {
        window.location.href = '../dashboard/';
      }else if(role ==="asst"){
        window.location.href = '../dash/';
      }else if(role ==="support"){
        window.location.href = '../dash-support/';
      }else {
        window.location.href = '../mydash/';
      }
    }

    const scrollTarget = localStorage.getItem('scrollTarget');
    if (scrollTarget) {      
      setTimeout(() => {
        this.smoothScroll(scrollTarget);
      }, 1000);
    }
    
  }
  
  scrollToSection(sectionId: string): void {
      const path = window.location.pathname;
      
      const isHome = path === '' || path === '/' || path.endsWith('/index') || path.endsWith('/index/');
      $('.fa-times').trigger('click');
      // Ferme le menu mobile
      const wrapper = document.getElementById('mobile-nav__wrapper');
      if (wrapper && wrapper.classList.contains('expanded')) {
        const toggler = document.querySelector('.mobile-nav__close') as HTMLElement;
        if (toggler) toggler.click();
      }

      if (isHome) {
        this.smoothScroll(sectionId);
      } else {
        // ✅ On est sur un child (functionalities, contact...), on navigue vers index puis scroll
          sessionStorage.setItem('scrollTarget', sectionId);
          this.router.navigate(['/index']).then(() => {
            setTimeout(() => {
              this.smoothScroll(sectionId);
            }, 500);
          });
      }
    }
  smoothScroll(sectionId: string): void {
    setTimeout(() => {
      const $target = $('#' + sectionId);
      if ($target.length) {
        $('html, body').animate({
          scrollTop: $target.offset()!.top - 70
        }, 300);
      }
    }, 300);
  }
  disconnect(){    
    this.logged=null;
    localStorage.removeItem("logged");
    sessionStorage.removeItem("logged");
    localStorage.removeItem("role");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("comp");
    localStorage.removeItem("comp");
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    localStorage.removeItem("fullname");
    sessionStorage.removeItem("fullname");
    sessionStorage.removeItem("msToken");
    localStorage.removeItem("msToken");
    sessionStorage.removeItem("userRoles");
    var restPack:any = null;
    localStorage.clear();
    sessionStorage.clear();
    window.location.href="/index";
    this.router.navigate(['/index']);
  }

  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    node.defer = true;
    var scriptsTags = document.getElementsByTagName('script');
    var exist = true;
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          exist = true;
          // document.getElementsByTagName("body")[0].appendChild(node);
          // break;
        }else {
          exist = true;
          break;
        }
    }
    if(!exist){
      document.getElementsByTagName("body")[0].appendChild(node);
    }
  }
  public loadStyle(link:string) {
    let node = document.createElement("link");
    node.href = link;
    node.type = "text/css";
    node.id = "css_landing";
    node.rel ="stylesheet";
    var linksTags = document.getElementsByTagName('link');
    for (var i = linksTags.length; i--;) {
        if (linksTags[i].href != link) {
          document.getElementsByTagName("head")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  preloader () {
    setTimeout(function () {
      $("#preloader").hide("slow");
    }, 1500);
    setTimeout(function () {
      $(".footer-section").css("display","none !important")
    }, 5000);
  }
  removeCssById(id: string) {
    const styleElement = document.getElementById(id);
    if (styleElement) {
      styleElement.remove(); // Removes the element from the DOM
    } else {
      console.log(`No CSS found with id '${id}'`);
    }
  };
}
